var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .secondP0 {\n        fill: #700;\n      }\n\n      .secondP1 {\n        fill: #0f2e7c;\n      }\n\n      .secondP2 {\n        fill: #3958b7;\n      }\n\n      .secondP3 {\n        fill: #c60000;\n      }\n\n      .secondP4 {\n        fill: #fff;\n      }\n\n      .secondP5 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .secondP6 {\n        fill: #ffbc00;\n      }\n\n      .secondP7 {\n        fill: #da1018;\n      }\n\n      .secondP8 {\n        display: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "secondP8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2099.8,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2037.62,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2161.97,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1913.27,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 1975.45,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2037.62,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2099.8,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2161.97,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2037.62,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2161.97,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2161.97,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2224.15,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2286.32,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2348.5,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2410.67,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2472.85,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -1759.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2286.32,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2348.5,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2410.67,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2472.85,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2286.32,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2348.5,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2410.67,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2286.32,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2348.5,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2410.67,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2224.15,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2286.32,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2348.5,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2410.67,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 1975.45,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2037.62,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2099.8,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1975.45,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2037.62,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2099.8,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2161.97,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 1913.27,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 1975.45,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2037.62,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2099.8,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2161.97,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 1913.27,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 1975.45,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2037.62,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2099.8,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 1913.27,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2161.97,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2224.15,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2286.32,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2348.5,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2410.67,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2286.32,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2348.5,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2410.67,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2286.32,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2348.5,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2410.67,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2224.15,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2224.15,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2224.15,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2161.97,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 2286.32,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2348.5,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2410.67,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2472.85,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2286.32,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2348.5,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2410.67,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2472.85,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2535.02,
    y: -1696.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2535.02,
    y: -1634.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2535.02,
    y: -1572.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2535.02,
    y: -1510.39,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -1448.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -1386.04,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -1323.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2535.02,
    y: -1261.69,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2535.02,
    y: -1199.51,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2099.8,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2224.15,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2286.32,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2348.5,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2410.67,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2472.85,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2535.02,
    y: -1137.34,
    width: 62.17,
    height: 62.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "secondP8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2099.8,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2037.62,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2161.97,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1913.27,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 1975.45,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2037.62,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2099.8,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2161.97,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2037.62,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2161.97,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2099.8,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2224.15,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2286.32,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2348.5,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2410.67,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2472.85,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -737.65,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2286.32,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2348.5,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2410.67,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2472.85,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2286.32,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2348.5,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2410.67,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2286.32,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2348.5,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2410.67,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2224.15,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2286.32,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2348.5,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2410.67,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 1975.45,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2037.62,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2099.8,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2161.97,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1913.27,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1975.45,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2037.62,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2099.8,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2161.97,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 1913.27,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 1975.45,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2037.62,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2099.8,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2161.97,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 1913.27,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 1975.45,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2037.62,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2099.8,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 1913.27,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1975.45,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2099.8,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2161.97,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2224.15,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2286.32,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2348.5,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2410.67,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2286.32,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2348.5,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2410.67,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2472.85,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2286.32,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2348.5,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2410.67,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2472.85,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2224.15,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2224.15,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2224.15,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2161.97,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP7",
    x: 2286.32,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2348.5,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2410.67,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2472.85,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2286.32,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2348.5,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2410.67,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2472.85,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2535.02,
    y: -675.48,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2535.02,
    y: -613.3,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2535.02,
    y: -551.13,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -488.95,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -426.78,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2535.02,
    y: -364.6,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2535.02,
    y: -302.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2535.02,
    y: -240.25,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2535.02,
    y: -178.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1913.27,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 1975.45,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2037.62,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2099.8,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2161.97,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2224.15,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 2286.32,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 2348.5,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP5",
    x: 2410.67,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 2472.85,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 2535.02,
    y: -115.9,
    width: 62.17,
    height: 62.17
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.47,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(-10.54 25.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-21.09 50.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-46.54 40.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 58.37,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(4.37 61.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-31.63 76.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-57.09 65.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-82.54 55.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 83.82,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-6.18 86.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 109.28,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(19.28 97.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.83,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-42.17 101.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-67.63 91.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.92,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-93.08 80.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-16.72 112.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 134.73,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(8.73 122.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 160.19,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(34.19 133.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-118.54 70.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-52.72 127.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-78.17 116.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-103.63 106.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-27.26 137.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.18,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-1.81 148.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 185.64,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(23.65 158.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 211.09,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(49.1 169.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.45,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-154.53 85.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-129.08 95.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-63.26 152.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-88.72 142.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-114.17 131.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 160.18,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-37.81 163.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(-12.35 173.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(13.1 184.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 236.55,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(38.56 194.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 262,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(64.01 205.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-190.53 100.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-165.08 110.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-139.63 121.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 160.17,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-73.81 178.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-99.26 167.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-124.71 157.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 185.64,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-48.35 188.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.08,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-22.9 199.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(2.56 209.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 261.99,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(28.01 220.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 287.46,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(53.47 230.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 312.91,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(78.92 241.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-226.53 114.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(-201.08 125.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-175.63 136.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-150.17 146.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 185.64,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-84.35 203.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 160.18,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-109.8 193.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-135.26 182.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 211.09,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-58.89 214.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 236.55,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-33.43 224.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 261.99,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-7.99 235.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(17.47 245.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.9,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(42.93 256.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(68.37 266.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 363.82,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(93.83 277.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.9,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-237.07 140.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-262.53 129.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-211.63 150.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-186.17 161.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-160.72 172.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 211.09,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-94.89 229.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 185.64,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-120.35 218.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 160.18,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-145.8 208) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 236.55,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-69.43 239.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 262,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-43.98 250.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-18.52 260.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(6.93 271.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(32.38 281.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.81,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(57.84 292.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 32.92,
    width: 36,
    height: 36,
    transform: "translate(83.28 302.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 414.73,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(108.74 313.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-247.62 165.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-273.07 155.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-298.52 144.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.81,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-222.16 176.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-196.72 186.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-171.26 197.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 236.55,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-105.44 254.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 211.09,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-130.89 244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 185.64,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-156.35 233.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 262,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-79.98 265.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-54.52 275.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-29.07 286.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 338.36,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-3.62 296.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 363.82,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(21.84 307.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(47.29 317.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(72.75 328.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(98.2 338.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 465.64,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(123.65 349.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-258.16 191.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-283.62 180.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-309.07 170.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-334.52 159.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 109.27,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-232.71 201.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 134.73,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-207.25 212.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 160.18,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-181.8 222.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 491.09,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-210.87 509.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-236.33 498.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-185.41 519.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-221.42 534.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 465.64,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-200.33 483.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 440.18,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-225.78 473.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-251.24 462.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 491.09,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-174.87 494.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-149.41 504.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 440.17,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-189.79 458.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 414.73,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-215.24 447.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-240.69 437.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 465.64,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-164.33 468.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.08,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-138.88 479.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-113.42 489.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.82,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-266.15 426.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 414.73,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-179.24 432.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-204.7 422.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.82,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-230.15 411.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-153.79 443.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-128.33 453.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-102.88 464.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-77.42 474.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-281.06 390.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 491.1,
    width: 36,
    height: 36,
    transform: "translate(-255.61 401.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-168.7 407.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.82,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-194.15 396.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-219.61 386.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-143.24 417.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-117.79 428.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(-92.33 438.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-66.88 449.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.54,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-41.42 459.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 262,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-295.97 354.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.45,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-270.51 365.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-245.06 375.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.83,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-158.15 381.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-183.61 371.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.92,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-209.06 360.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-132.7 392.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-107.25 402.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 440.19,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-81.79 413.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-56.33 423.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.1,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-30.89 434.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-5.42 445.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-310.89 318.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-285.42 329.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 262.01,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-259.97 339.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 287.45,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-234.52 350.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-147.61 356.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 312.91,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-173.07 345.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-198.52 335.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-122.16 366.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.28,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-96.7 377.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 414.73,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(-71.24 387.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 440.19,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-45.8 398.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-20.33 409.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.1,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(5.11 419.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(30.57 430.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-300.33 293.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.19,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-325.8 282.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.1,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-274.89 303.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 236.55,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-249.43 314.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 262.01,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-223.97 324.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-137.07 330.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-162.52 320.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 262,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-187.98 309.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.37,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-111.61 341.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-86.16 352) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.28,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-60.71 362.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(-35.24 373.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.19,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-9.8 383.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(15.66 394.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(41.12 404.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(66.57 415.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.19,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-289.8 267.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 491.08,
    width: 36,
    height: 36,
    transform: "translate(-315.24 257.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.28,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-340.71 246.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-264.34 278.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-238.88 288.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-213.43 299.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.47,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(-126.52 305.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 262,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-151.98 294.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-177.43 284.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-101.07 316) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.37,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-75.62 326.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-50.16 337.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-24.71 347.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(.75 358.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.18,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(26.2 368.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(51.66 379.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(77.11 389.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 516.55,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(102.57 400.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-279.25 242.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-304.71 231.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-330.16 221.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 58.37,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-355.62 210.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.18,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-253.8 252.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-228.34 263.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 211.09,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-202.89 273.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 262,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-115.98 280) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 236.56,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(-141.43 269.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-166.89 258.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-90.52 290.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-65.07 301.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-39.62 311.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 363.82,
    y: 160.17,
    width: 36,
    height: 36,
    transform: "translate(-14.16 322.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(11.29 332.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 414.73,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(36.75 343.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.18,
    y: 83.83,
    width: 36,
    height: 36,
    transform: "translate(62.2 353.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(87.66 364.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 491.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(113.11 374.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 516.56,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(138.57 385.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 109.27,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-268.71 216.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 440.17,
    width: 36,
    height: 36,
    transform: "translate(-294.16 206.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-319.62 195.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 32.91,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-345.07 185.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-370.52 174.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-243.25 227.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 160.18,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-217.8 237.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-192.34 248.37) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.55,
    y: 7.44,
    width: 36,
    height: 36,
    transform: "translate(302.59 781.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(277.13 770.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(266.59 796.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1025.64,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(287.68 745.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(251.68 760.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.1,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(241.13 785.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(230.59 811.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1000.19,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(262.22 734.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 974.73,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(272.77 709.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.19,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(226.22 749.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(215.68 775.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.1,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(205.14 800.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.72,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(236.76 724.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 949.28,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(247.31 698.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 923.82,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(257.86 673.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(194.59 826.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.73,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(200.77 739.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(190.22 764.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(179.68 790.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(211.31 713.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(221.85 688.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 898.36,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(232.4 662.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 872.91,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(242.95 637.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(158.59 841.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(169.14 815.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(175.31 728.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.73,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(164.77 754.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(154.23 779.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 923.82,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(185.86 703.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.36,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(196.4 677.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(206.94 652.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 847.46,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(217.49 626.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 822,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(228.04 601.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.55,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(122.6 855.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(133.14 830.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.64,
    y: 211.08,
    width: 36,
    height: 36,
    transform: "translate(143.69 805.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 923.82,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(149.86 718.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(139.32 743.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.72,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(128.77 769.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 898.37,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(160.4 692.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(170.94 667.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.46,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(181.5 641.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 821.99,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(192.03 616.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 796.55,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(202.58 590.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 771.09,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(213.12 565.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(86.6 870.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(97.15 845.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(107.69 819.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(118.23 794.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 898.37,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(124.4 707.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 923.81,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(113.86 733.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.28,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(103.32 758.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 872.9,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(134.95 682.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 847.45,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(145.5 656.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 821.99,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(156.03 631.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(166.58 605.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(177.12 580.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.63,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(187.67 554.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 720.19,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(198.21 529.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.08,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(61.14 860.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(50.6 885.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(71.69 834.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.19,
    y: 287.46,
    width: 36,
    height: 36,
    transform: "translate(82.23 809.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.72,
    y: 261.99,
    width: 36,
    height: 36,
    transform: "translate(92.78 783.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 872.91,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(98.95 697.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 898.37,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(88.41 722.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 923.81,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(77.86 747.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 847.45,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(109.5 671.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 822,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(120.03 646.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.54,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(130.58 620.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(141.12 595.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(151.67 569.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(162.21 544.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.72,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(172.76 518.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 669.28,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(183.3 493.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(35.69 849.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(25.14 875.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(14.6 900.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(46.23 824.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.72,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(56.78 798.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.28,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(67.32 773.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 847.45,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(73.5 686.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 872.91,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(62.95 711.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 898.37,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(52.41 737.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 822,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(84.04 661.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.54,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(94.58 635.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(105.12 610.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 745.63,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(115.67 584.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 720.18,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(126.21 559.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(136.76 533.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(147.29 508.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(157.85 482.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 618.37,
    y: 7.45,
    width: 36,
    height: 36,
    transform: "translate(168.39 457.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(10.23 839.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-.31 864.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-10.86 890.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-21.4 915.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 974.72,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(20.78 813.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 949.27,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(31.31 788.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 923.82,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(41.87 762.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 592.91,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-181.05 581.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-191.59 606.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-170.5 555.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-206.5 570.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 618.37,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-155.6 591.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 643.81,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-166.14 617.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.28,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-176.68 642.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 592.9,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-145.05 566.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-134.5 540.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 643.81,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-130.14 602.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 669.28,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-140.68 627.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-151.23 653.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 618.37,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-119.6 576.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.9,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-109.06 551.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-98.5 525.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-161.77 678.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 669.27,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-104.69 612.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.73,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-115.23 638.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-125.77 663.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-94.14 587.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-83.6 561.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-73.06 536.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.46,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-62.51 510.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-146.86 714.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 491.08,
    width: 36,
    height: 36,
    transform: "translate(-136.31 689.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.73,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-79.23 623.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-89.77 648.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.64,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-100.32 674.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-68.69 597.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-58.15 572.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-47.6 546.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(-37.05 521.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-26.51 495.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 822,
    y: 516.55,
    width: 36,
    height: 36,
    transform: "translate(-131.95 750.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-121.41 725.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-110.86 699.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.19,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-53.78 633.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-64.32 659.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.1,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-74.86 684.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-43.23 608.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.28,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-32.69 582.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 643.83,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(-22.14 557.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-11.61 531.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.92,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-1.05 506.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(9.49 481.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.92,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-117.03 786.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-106.49 761.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 822.01,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-95.95 735.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 796.54,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-85.41 710.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.63,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-28.32 644.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 771.1,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(-38.87 669.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-49.41 695.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.19,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-17.78 618.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(-7.23 593.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 669.28,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(3.3 567.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 643.82,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(13.86 542.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(24.39 517.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(34.94 491.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 160.17,
    width: 36,
    height: 36,
    transform: "translate(45.49 466.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.37,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-91.59 797.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-102.12 822.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 465.64,
    width: 36,
    height: 36,
    transform: "translate(-81.04 771.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 847.45,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-70.49 746.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 822.01,
    y: 414.72,
    width: 36,
    height: 36,
    transform: "translate(-59.95 720.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(-2.87 654.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(-13.41 680.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 822,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-23.95 705.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 287.45,
    width: 36,
    height: 36,
    transform: "translate(7.68 629.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.19,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(18.22 603.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(28.77 578.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.28,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(39.3 553.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(49.85 527.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(60.39 502.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(70.94 476.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(81.48 451.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-66.12 807.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.28,
    y: 491.1,
    width: 36,
    height: 36,
    transform: "translate(-76.68 833.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.73,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-87.21 858.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.37,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-55.59 782.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-45.04 756.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-34.5 731.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.55,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(22.59 665.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 822,
    y: 312.91,
    width: 36,
    height: 36,
    transform: "translate(12.04 690.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 338.36,
    width: 36,
    height: 36,
    transform: "translate(1.5 716.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(33.13 639.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(43.68 614.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.18,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(54.21 589.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(64.77 563.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(75.3 538.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(85.85 512.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(96.39 487.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(106.94 461.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 567.45,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(117.48 436.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 440.18,
    width: 36,
    height: 36,
    transform: "translate(-40.68 818.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.73,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-51.21 843.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 491.1,
    width: 36,
    height: 36,
    transform: "translate(-61.77 869.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1025.64,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-72.3 894.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-30.13 792.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.37,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-19.59 767.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 872.91,
    y: 363.81,
    width: 36,
    height: 36,
    transform: "translate(-9.04 741.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 822,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(48.04 675.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 847.45,
    y: 287.44,
    width: 36,
    height: 36,
    transform: "translate(37.5 701.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 312.9,
    width: 36,
    height: 36,
    transform: "translate(26.96 726.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.55,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(58.59 650.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(69.13 625.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(79.68 599.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 720.18,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(90.21 574.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(100.76 548.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 669.27,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(111.3 523.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(121.85 497.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(132.38 472.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 592.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(142.93 446.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 567.45,
    y: 7.44,
    width: 36,
    height: 36,
    transform: "translate(153.48 421.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 974.73,
    y: 414.73,
    width: 36,
    height: 36,
    transform: "translate(-15.22 828.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-25.77 854.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.64,
    y: 465.63,
    width: 36,
    height: 36,
    transform: "translate(-36.3 879.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1051.09,
    y: 491.09,
    width: 36,
    height: 36,
    transform: "translate(-46.85 905.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 516.54,
    width: 36,
    height: 36,
    transform: "translate(-57.4 930.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 389.27,
    width: 36,
    height: 36,
    transform: "translate(-4.68 803.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 923.82,
    y: 363.82,
    width: 36,
    height: 36,
    transform: "translate(5.87 777.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.36,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(16.4 752.34) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 1076.56,
    width: 36,
    height: 36,
    transform: "translate(-766.51 338.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-741.05 349.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 1025.65,
    width: 36,
    height: 36,
    transform: "translate(-730.51 323.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 58.36,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-751.6 374.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-715.6 359.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-705.05 334.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-694.51 308.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 83.82,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-726.14 385.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 109.27,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-736.69 410.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.83,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-690.14 370.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-679.6 344.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.92,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-669.05 319.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-700.69 395.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 134.73,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-711.23 421.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 160.18,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-721.77 446.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-658.51 293.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-664.69 380.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-654.14 355.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-643.6 329.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-675.23 406.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.18,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-685.78 431.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 185.64,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-696.32 457.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 211.09,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-706.86 482.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.45,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-622.51 278.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-633.05 304.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-639.23 391.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-628.69 365.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-618.14 340.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 160.18,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-649.78 416.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-660.32 442.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-670.86 467.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 236.55,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-681.41 493.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 262,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-691.96 518.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-586.51 264.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-597.06 289.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 872.9,
    width: 36,
    height: 36,
    transform: "translate(-607.6 314.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 160.18,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-613.78 401.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.73,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-603.23 376.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.28,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-592.69 350.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 185.64,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-624.32 427.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.08,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-634.87 452.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-645.41 478.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 261.99,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-655.95 503.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 287.46,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-666.5 529.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 312.9,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-677.05 554.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-550.52 249.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-561.07 274.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.37,
    y: 821.99,
    width: 36,
    height: 36,
    transform: "translate(-571.6 300.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.81,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-582.15 325.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 185.64,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-588.32 412.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 160.18,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-577.78 386.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.72,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-567.24 361.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 211.09,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-598.87 437.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 236.55,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-609.41 463.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 261.99,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-619.96 488.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-630.5 514.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.9,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-641.05 539.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-651.58 565.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 363.81,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-662.13 590.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.9,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-525.07 259.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-514.52 234.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-535.6 285.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.81,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-546.15 310.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 821.99,
    width: 36,
    height: 36,
    transform: "translate(-556.69 336.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 211.09,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-562.87 422.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 185.63,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-552.33 397.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 160.18,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-541.78 372.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 236.55,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-573.41 448.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 262,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-583.95 473.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-594.5 499.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-605.05 524.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-615.58 550.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.81,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-626.14 575.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 1051.08,
    width: 36,
    height: 36,
    transform: "translate(-636.67 601.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 414.72,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-647.22 626.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-499.6 270.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 694.72,
    width: 36,
    height: 36,
    transform: "translate(-489.06 244.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-478.52 219.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.81,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-510.16 295.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 109.27,
    y: 771.08,
    width: 36,
    height: 36,
    transform: "translate(-520.69 321.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 134.72,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-531.24 346.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 236.54,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-537.42 433.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 211.09,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-526.87 408.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 185.63,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-516.33 382.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 262,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-547.96 458.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-558.5 484.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-569.04 509.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 338.36,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-579.59 535.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 363.82,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-590.14 560.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-600.67 586.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-611.22 611.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-621.76 637.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 465.63,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-632.31 662.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-474.16 280.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-463.61 255.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 32.91,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-453.06 229.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.46,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-442.52 204.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 109.27,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-484.69 306.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 134.73,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-495.24 331.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 160.18,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-505.78 357.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 491.09,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-282.87 538.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.63,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-272.33 513.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-293.41 564.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.54,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-257.42 549.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 465.64,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-308.32 528.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 440.18,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-297.78 502.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.72,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-287.24 477.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 491.09,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-318.87 553.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-329.41 579.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 440.17,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-333.78 517.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 414.73,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-323.23 492.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-312.69 466.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 465.64,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-344.32 543.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.08,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-354.87 568.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-365.41 594.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.81,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-302.15 441.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 414.73,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-359.23 507.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-348.69 481.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.82,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-338.14 456.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-369.78 532.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-380.32 558.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-390.86 583.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-401.41 609.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-317.06 405.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 592.9,
    width: 36,
    height: 36,
    transform: "translate(-327.6 430.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 389.27,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-384.69 496.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 363.82,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-374.14 471.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 643.81,
    width: 36,
    height: 36,
    transform: "translate(-363.6 445.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-395.23 522.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 440.18,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-405.78 547.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-416.32 573.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-426.86 598.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.54,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-437.41 624.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 262,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-331.98 369.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.45,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-342.51 394.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-353.05 420.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.83,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-410.14 486.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-399.6 460.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.92,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-389.05 435.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-420.69 511.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-431.23 537.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 440.18,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-441.77 562.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-452.32 588.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-462.86 613.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-473.41 638.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-346.88 333.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-357.43 358.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 262.01,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-367.97 384.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 287.46,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-378.51 409.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 338.36,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-435.6 475.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 312.91,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-425.05 450.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-414.51 424.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-446.14 501.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-456.69 526.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 414.73,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-467.23 552.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 440.18,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-477.77 577.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-488.32 602.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.1,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-498.86 628.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-509.4 653.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-372.34 322.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.18,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-361.79 297.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.1,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-382.87 348.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 236.55,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-393.42 373.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 262.01,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-403.96 399.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-461.05 465.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 287.46,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-450.51 439.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 262,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-439.96 414.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-471.6 490.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-482.14 516.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-492.68 541.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-503.23 566.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.19,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-513.76 592.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-524.31 617.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-534.86 643.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 516.55,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-545.4 668.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.19,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-397.78 312.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-387.25 286.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-376.7 261.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-408.34 337.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-418.88 363.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-429.42 388.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.46,
    y: 796.56,
    width: 36,
    height: 36,
    transform: "translate(-486.51 454.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 262,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-475.96 429.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 236.55,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-465.42 403.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 312.91,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-497.05 480.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-507.59 505.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 363.82,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-518.13 530.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-528.68 556.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 414.73,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-539.23 581.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.18,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-549.76 607.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-560.31 632.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 491.09,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-570.86 658.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 516.55,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-581.4 683.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-423.25 301.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 109.27,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-412.7 276.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-402.15 250.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 58.36,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-391.62 225.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 160.18,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-433.78 327.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-444.33 352.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 211.09,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-454.88 378.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 262,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-511.96 444.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 236.55,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-501.42 418.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 211.09,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-490.87 393.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 287.45,
    y: 847.47,
    width: 36,
    height: 36,
    transform: "translate(-522.51 469.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 312.91,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-533.05 494.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 338.36,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-543.59 520.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 363.82,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-554.14 545.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 389.27,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-564.67 571.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 414.73,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-575.22 596.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 440.18,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-585.77 622.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 465.64,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-596.31 647.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 491.09,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-606.85 673.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 516.55,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-617.4 698.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 109.27,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-448.69 291.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 83.82,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-438.16 265.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 58.36,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-427.61 240.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 32.91,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-417.07 214.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 7.45,
    y: 567.47,
    width: 36,
    height: 36,
    transform: "translate(-406.53 189.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 134.73,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-459.24 316.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 160.18,
    y: 720.17,
    width: 36,
    height: 36,
    transform: "translate(-469.78 342.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 185.64,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-480.33 367.66) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-453.38 1094.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-442.83 1069.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-417.38 1079.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1025.63,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-468.28 1058.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-432.29 1043.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.1,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-406.83 1054.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-381.38 1064.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1000.19,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-457.74 1033.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 974.72,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-483.2 1022.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.19,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-421.74 1018.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-396.29 1028.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.1,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-370.84 1039.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.72,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-447.2 1007.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 949.28,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-472.65 997.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 923.81,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-498.11 986.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-345.38 1049.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.73,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-411.2 992.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.19,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-385.74 1003.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-360.29 1013.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-436.65 982.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-462.11 971.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 898.36,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-487.57 961.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 872.91,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-513.02 950.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 872.92,
    width: 36,
    height: 36,
    transform: "translate(-309.39 1034.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-334.84 1024.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-400.66 967.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.73,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-375.2 977.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-349.75 988.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 923.82,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-426.12 956.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.36,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-451.57 946.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-477.02 935.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 847.45,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-502.48 925.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 822,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-527.93 914.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.55,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-273.39 1019.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-298.84 1009.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.64,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-324.29 998.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 923.82,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-390.12 941.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-364.66 952.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.73,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-339.2 962.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 898.37,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-415.56 931.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-441.02 920.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.46,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-466.48 910.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 822,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-491.93 899.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 796.55,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-517.39 889.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 771.09,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-542.84 878.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.55,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-237.39 1005.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-262.84 994.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.64,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-288.3 983.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-313.75 973.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 898.37,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-379.57 916.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 923.81,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-354.12 926.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-328.66 937.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 872.9,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-405.03 905.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 847.45,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-430.48 895.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 821.99,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-455.93 884.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-481.39 874.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.08,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-506.84 863.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.63,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-532.3 853.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 720.18,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-557.75 842.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.08,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-226.84 979.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-201.39 990.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-252.3 969.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-277.75 958.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.72,
    y: 822.01,
    width: 36,
    height: 36,
    transform: "translate(-303.21 947.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 872.9,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-369.03 890.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 898.36,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-343.57 901.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 923.81,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-318.12 911.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 847.45,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-394.48 880.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 822,
    y: 923.81,
    width: 36,
    height: 36,
    transform: "translate(-419.93 869.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.54,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-445.4 859.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-470.84 848.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-496.3 838.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-521.75 827.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.72,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-547.21 817.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 669.27,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-572.66 806.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-216.3 954.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 694.72,
    width: 36,
    height: 36,
    transform: "translate(-190.84 964.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-165.4 975.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-241.75 943.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 974.72,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-267.21 933.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 949.27,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-292.66 922.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 847.44,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-358.48 865.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 872.91,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-333.03 876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 898.36,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-307.57 886.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 822,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-383.94 854.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.54,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-409.4 844.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 923.81,
    width: 36,
    height: 36,
    transform: "translate(-434.84 833.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 745.63,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-460.31 823.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 720.18,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-485.75 812.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 1000.18,
    width: 36,
    height: 36,
    transform: "translate(-511.21 802.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-536.66 791.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 1051.1,
    width: 36,
    height: 36,
    transform: "translate(-562.12 781.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 618.36,
    y: 1076.54,
    width: 36,
    height: 36,
    transform: "translate(-587.57 770.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-205.75 928.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.63,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-180.31 939.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 1051.09,
    y: 643.81,
    width: 36,
    height: 36,
    transform: "translate(-154.84 949.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.54,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-129.4 960.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 974.72,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-231.21 918.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 949.27,
    y: 745.63,
    width: 36,
    height: 36,
    transform: "translate(-256.66 907.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 923.82,
    y: 771.1,
    width: 36,
    height: 36,
    transform: "translate(-282.12 897.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 592.91,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-253.05 610.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-227.59 621.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-278.51 600.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.44,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-242.5 585.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 618.37,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-263.59 636.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 643.81,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-238.14 646.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-212.68 657.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 592.9,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-289.05 625.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-314.5 615.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 643.82,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-274.14 661.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 669.27,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-248.68 672.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-223.22 682.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 618.37,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-299.59 651.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 694.72,
    width: 36,
    height: 36,
    transform: "translate(-325.04 640.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.46,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-350.5 630.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-197.77 693.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 669.27,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-284.68 687.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.73,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-259.22 697.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-233.77 708.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-310.14 676.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-335.59 666.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 745.63,
    width: 36,
    height: 36,
    transform: "translate(-361.04 655.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-386.5 645.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-182.86 729.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-208.31 718.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 694.73,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-295.22 712.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 720.18,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-269.76 723.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.63,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-244.31 733.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-320.67 702.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 643.82,
    y: 745.63,
    width: 36,
    height: 36,
    transform: "translate(-346.13 691.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-371.59 681.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-397.04 670.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-422.5 660.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 822,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-167.94 765.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 592.92,
    width: 36,
    height: 36,
    transform: "translate(-193.41 754.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-218.86 744.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.19,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-305.76 738.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-280.31 748.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.1,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-254.86 759.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 745.63,
    width: 36,
    height: 36,
    transform: "translate(-331.22 727.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.28,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-356.67 717.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 643.81,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-382.13 706.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 821.99,
    width: 36,
    height: 36,
    transform: "translate(-407.58 696.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 847.46,
    width: 36,
    height: 36,
    transform: "translate(-433.04 685.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-458.5 674.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 567.46,
    width: 36,
    height: 36,
    transform: "translate(-153.04 801.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-178.5 790.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 822.01,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-203.95 780.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 796.54,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-229.4 769.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 745.63,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-316.31 763.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 771.1,
    y: 720.18,
    width: 36,
    height: 36,
    transform: "translate(-290.85 774.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-265.4 784.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.19,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-341.76 753.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-367.22 742.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 669.28,
    y: 821.99,
    width: 36,
    height: 36,
    transform: "translate(-392.67 732.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 643.81,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-418.13 721.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-443.58 710.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-469.04 700.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 923.83,
    width: 36,
    height: 36,
    transform: "translate(-494.5 689.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.37,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-163.58 826.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.81,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-138.13 837.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 618.36,
    width: 36,
    height: 36,
    transform: "translate(-189.04 816.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 847.45,
    y: 643.83,
    width: 36,
    height: 36,
    transform: "translate(-214.5 805.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 822,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-239.95 795.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-326.85 789.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 796.54,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-301.4 799.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 822,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-275.95 810.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 796.54,
    width: 36,
    height: 36,
    transform: "translate(-352.31 778.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.18,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-377.76 768) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.72,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-403.22 757.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.28,
    y: 872.9,
    width: 36,
    height: 36,
    transform: "translate(-428.67 746.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 898.36,
    width: 36,
    height: 36,
    transform: "translate(-454.12 736.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.37,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-479.58 725.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 949.28,
    width: 36,
    height: 36,
    transform: "translate(-505.04 715.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 567.45,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-530.49 704.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-174.13 852.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.28,
    y: 592.9,
    width: 36,
    height: 36,
    transform: "translate(-148.67 862.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.72,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-123.22 873.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.37,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-199.58 841.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 669.28,
    width: 36,
    height: 36,
    transform: "translate(-225.04 831.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-250.49 820.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.54,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-337.4 814.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 822,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-311.94 825.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 847.45,
    y: 745.64,
    width: 36,
    height: 36,
    transform: "translate(-286.49 835.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 771.09,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-362.85 804) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.63,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-388.3 793.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 720.18,
    y: 872.9,
    width: 36,
    height: 36,
    transform: "translate(-413.76 782.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-439.22 772.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 669.27,
    y: 923.82,
    width: 36,
    height: 36,
    transform: "translate(-464.67 761.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-490.12 751.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 974.72,
    width: 36,
    height: 36,
    transform: "translate(-515.57 740.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 592.91,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-541.04 730.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 567.45,
    y: 1025.64,
    width: 36,
    height: 36,
    transform: "translate(-566.49 719.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 643.82,
    width: 36,
    height: 36,
    transform: "translate(-184.67 877.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 974.73,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-159.22 888.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 592.9,
    width: 36,
    height: 36,
    transform: "translate(-133.76 898.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1025.63,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-108.3 909.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 923.82,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-210.12 867.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.36,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-235.58 856.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP4",
    x: 872.91,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-261.04 846.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP0",
    x: 822,
    y: 822,
    width: 36,
    height: 36,
    transform: "translate(-347.94 840) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 847.44,
    y: 796.55,
    width: 36,
    height: 36,
    transform: "translate(-322.49 850.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 872.91,
    y: 771.09,
    width: 36,
    height: 36,
    transform: "translate(-297.03 861.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP3",
    x: 796.53,
    y: 847.45,
    width: 36,
    height: 36,
    transform: "translate(-373.4 829.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 771.09,
    y: 872.91,
    width: 36,
    height: 36,
    transform: "translate(-398.85 818.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 745.64,
    y: 898.37,
    width: 36,
    height: 36,
    transform: "translate(-424.31 808.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 720.18,
    y: 923.81,
    width: 36,
    height: 36,
    transform: "translate(-449.76 797.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 694.73,
    y: 949.27,
    width: 36,
    height: 36,
    transform: "translate(-475.21 787.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 669.27,
    y: 974.73,
    width: 36,
    height: 36,
    transform: "translate(-500.67 776.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 643.82,
    y: 1000.19,
    width: 36,
    height: 36,
    transform: "translate(-526.12 766.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 618.36,
    y: 1025.63,
    width: 36,
    height: 36,
    transform: "translate(-551.57 755.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 592.91,
    y: 1051.09,
    width: 36,
    height: 36,
    transform: "translate(-577.03 745.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 567.44,
    y: 1076.55,
    width: 36,
    height: 36,
    transform: "translate(-602.49 734.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 974.73,
    y: 669.27,
    width: 36,
    height: 36,
    transform: "translate(-195.21 903.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1000.18,
    y: 643.81,
    width: 36,
    height: 36,
    transform: "translate(-169.76 913.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 1025.64,
    y: 618.37,
    width: 36,
    height: 36,
    transform: "translate(-144.31 924.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1051.09,
    y: 592.91,
    width: 36,
    height: 36,
    transform: "translate(-118.85 934.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP1",
    x: 1076.53,
    y: 567.45,
    width: 36,
    height: 36,
    transform: "translate(-93.39 945.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 949.27,
    y: 694.73,
    width: 36,
    height: 36,
    transform: "translate(-220.67 892.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP6",
    x: 923.82,
    y: 720.19,
    width: 36,
    height: 36,
    transform: "translate(-246.12 882.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "secondP2",
    x: 898.36,
    y: 745.63,
    width: 36,
    height: 36,
    transform: "translate(-271.57 871.63) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondP);
export default __webpack_public_path__ + "static/media/SecondP.0e6333efef142d2dbb25d677879d3d97.svg";
export { ForwardRef as ReactComponent };